export default "__VITE_ASSET__BUTtPoLT__"